import { useState } from 'react'
const generateId = (): string => Math.random().toString(36).substr(2, 9)

const useId = (passedId?: string): string => {
  const [id] = useState(passedId || generateId)
  return id
}

export default useId
